/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_rv_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free text reverser. Reverse text by characters, words, or lines. Emoji-safe and runs in your browser.`)
};

const es_rv_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inversor de texto gratuito. Invierte texto por caracteres, palabras o líneas. Compatible con emoji y se ejecuta en tu navegador.`)
};

const de_rv_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Text-Umkehrer. Kehre Text nach Zeichen, Wörtern oder Zeilen um. Emoji-sicher und läuft in deinem Browser.`)
};

const nl_rv_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis tekstomdraaier. Draai tekst om op tekens, woorden of lijnen. Veilig voor emoji's en draait in je browser.`)
};

const fr_rv_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inverseur de texte gratuit. Inversez le texte par caractères, mots ou lignes. Sûr pour les emoji et fonctionne dans votre navigateur.`)
};

const it_rv_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invertitore di testo gratuito. Inverti il testo per caratteri, parole o righe. Sicuro per emoji e funziona nel tuo browser.`)
};

const pt_br2_rv_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inversor de texto gratuito. Inverta o texto por caracteres, palavras ou linhas. Seguro para emojis e executado no seu navegador.`)
};

const pt_rv_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inversor de texto gratuito. Inverta texto por caracteres, palavras ou linhas. Seguro para emoji e funciona no seu navegador.`)
};

const ja_rv_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料のテキストリバーサーです。文字、単語、または行単位でテキストを反転させます。絵文字に対応しており、ブラウザで実行されます。`)
};

const zh_rv_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费文本反转器。按字符、单词或行反转文本。对表情符号安全，完全在浏览器中运行。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const rv_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.rv_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("rv_tool_description", locale)
	if (locale === "en") return en_rv_tool_description(inputs)
	if (locale === "es") return es_rv_tool_description(inputs)
	if (locale === "de") return de_rv_tool_description(inputs)
	if (locale === "nl") return nl_rv_tool_description(inputs)
	if (locale === "fr") return fr_rv_tool_description(inputs)
	if (locale === "it") return it_rv_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_rv_tool_description(inputs)
	if (locale === "pt") return pt_rv_tool_description(inputs)
	if (locale === "ja") return ja_rv_tool_description(inputs)
	return zh_rv_tool_description(inputs)
};